import * as Sentry from '@sentry/vue';

interface FetchOptions extends RequestInit {
  body?: any;
}

export async function fetchWrapper<T>(url: string, options: FetchOptions = {}, context: {}): Promise<T> {

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      Sentry.captureException(new Error(`Fetch error: ${response.statusText}`), {
        tags: {
          'response.status': response.status,
          'response.statusText': response.statusText,
        },
        extra: {
          ...context,
          options: JSON.stringify(options.body || {})
        }
      });
    }


    const text = await response.text();
    if (!text || text.trim() === '') {
      return null as T;
    }

    try {
      return JSON.parse(text);
    } catch (jsonError) {
      console.error(`Failed to parse JSON from ${url}:`, text);
      throw new Error(`Invalid JSON response: ${text.substring(0, 100)}`);
    }
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        'status': JSON.stringify(error),
      },
      extra: {
        context: {
          ...context,
          options: JSON.stringify(options.body || {})
        },
        body: JSON.stringify(options.body || {})
      }
    });
    console.error(`Error in ${context}:`, error);
    throw error;
  }
}